module.exports = __webpack_public_path__ + "static/media/taoshan_web.296fb00e.webp";